import React from "react";
import * as styles from "./SectionHeader.module.scss";

export const SectionHeader = ({ children }: { children: React.ReactNode }) => {
  return <h3 className={styles.heading}>{children}</h3>;
};
